import LocationAutocompleteInput from './LocationAutocompleteInput';

export default LocationAutocompleteInput;

export type SimpleItem = import('./LocationAutocompleteInput').SimpleItem;
